import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useAuthStore } from '../store/useAuthStore';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { isAuthenticated, user, isAuthLoaded } = useAuthStore(); // Access authentication state
  const location = useLocation(); // Get the current location

  // Wait until auth is fully loaded before deciding navigation
  if (!isAuthLoaded) return null; // Prevents rendering before auth is initialized

  // Store the current location for redirecting back after login
  const redirectTo = encodeURIComponent(location.pathname + location.search);

  // Redirect to login page if the user is not authenticated
  if (!isAuthenticated) return <Navigate to={`/?redirect=${redirectTo}`} />;

  // Redirect to unauthorized page if the user's role is not allowed
  if (allowedRoles && !allowedRoles.includes(user?.role))
    return <Navigate to="/dashboard/unauthorized" />;

  // Render the protected content if all checks pass
  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired, // The child components to render
  allowedRoles: PropTypes.arrayOf(PropTypes.string), // Array of roles allowed to access the route
};

export default ProtectedRoute;
